// assets
import { IconTypography, IconPalette, IconShadow, IconWindmill, IconMailbox, IconNotebook, IconLicense } from '@tabler/icons';

// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconMailbox,
    IconNotebook,
    IconLicense
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const proposal = {
    id: 'proposal',
    title: 'Proposal',
    type: 'group',
    children: [
        {
            id: 'util-typography',
            title: 'Inbox Proposal',
            type: 'item',
            url: '/proposal/proposal-persetujuan/list',
            icon: icons.IconMailbox,
            breadcrumbs: false,
            roles: ['MARKETING']
        },
        {
            id: 'util-color',
            title: 'Daftar Proposal',
            type: 'item',
            url: '/proposal/proposal/list',
            icon: icons.IconNotebook,
            breadcrumbs: false
        },
        {
            id: 'util-shadow',
            title: 'Riwayat Persetujuan',
            type: 'item',
            url: '/proposal/proposal-log/list',
            icon: icons.IconLicense,
            breadcrumbs: false,
            roles: ['MARKETING']
        }
    ]
};

export default proposal;
